import React from "react";
import helpersNumbers from "../../../helpers/numbers";
import UserExample from "../../sections/UserExample";

export default function AccountBalance() {
  return (
    <div className="px-2 ">
      <div className="d-flex">
        <div className="nav-item d-flex align-items-center px-3 py-2 finance-number">
          <span dir="ltr"> : موجودی </span>
          <span className="px-2 letter-spacing-finance-number">
            {helpersNumbers.toPersianNum(
              helpersNumbers.toFormatFinanceNumber(UserExample.wallet)
            )}
          </span>
          <span>تومان</span>
        </div>
        <div className="nav-item d-flex align-items-center px-3 py-2 finance-number">
          <span dir="ltr"> : امتیاز </span>
          <span className="px-2 letter-spacing-finance-number">
            {helpersNumbers.toPersianNum(
              helpersNumbers.toFormatFinanceNumber(UserExample.score)
            )}
          </span>
        </div>
      </div>
    </div>
  );
}
